<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for1"><a id="page_vii"></a><a href="#/xhtml/Foreword#for"><i>Foreword</i> by Lillian Daniel</a></p>
<p class="Toc1" id="ack1"><a href="#/xhtml/Acknowledgments#ack">Acknowledgments</a></p>
<p class="Toc1" id="int1"><a href="#/xhtml/Introduction#int">Introduction</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/Chapter001#ch001">1.<span class="space">The Symphony of Miriam</span></a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/Chapter002#ch002" title="Link target outside of Sample">2.<span class="space">Asking Permission</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/Chapter003#ch003" title="Link target outside of Sample">3.<span class="space">Voice Lost</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/Chapter004#ch004" title="Link target outside of Sample">4.<span class="space">Voice Restored</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/Chapter005#ch005" title="Link target outside of Sample">5.<span class="space">Embodied Voice</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/Chapter006#ch006" title="Link target outside of Sample">6.<span class="space">As If It Matters</span></span></p>
<p class="Toc1" id="con1"><span href="#/xhtml/Conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="Toc1" id="not1"><span href="#/xhtml/Notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="Toc1" id="bib1"><span href="#/xhtml/Bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="ind1"><span href="#/xhtml/Index001#ind" title="Link target outside of Sample">Index of Names and Subjects</span></p>
<p class="Toc1" id="indx1"><span href="#/xhtml/Index002#indx" title="Link target outside of Sample">Index of Scripture References</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?01cc7979